/**
 * The @aircall/ds Button size token shared by every icon-only action in the page
 * header row (share link, export, help), sized to match the height of the
 * feedback button sitting at the end of that row.
 */
export const HEADER_ACTION_BUTTON_SIZE = "icon";
